var _a;
import { WebGLErrorEnum } from '../models/webgl-error.enum';
// default config
export var defaultWebGLErrorConfig = {
    title: 'WebGL Error',
    description: "It appears your browser isn't supporting WebGL, the HTML standard used to view 3D graphics."
};
// custom user defined messages based on web gl errors
export var webGLErrorConfig = (_a = {},
    _a[WebGLErrorEnum.WebGLNotSupported] = {
        title: 'WebGL Unsupported',
        description: "It appears your browser isn't supporting WebGL, the HTML standard used to view 3D graphics."
    },
    _a);
